import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        
        // Common
        welcome: "Welcome to e-Gram Panchayat",
        projectTitle: "Empowering Residency",
        home: "Home",
        register: "Register",
        login: "Login",
        logout: "Logout",
        admin: "Admin",
        dashboard: "Dashboard",
        complaints: "Complaints",
        users: "Users",
        raiseComplaint: "Raise Complaint",
        myComplaints: "My Complaints",
        kyc: "KYC",
        PublicInfo: "Public Info",
        Statistics:"Statistics",
        profile: "Profile",
        managerDashboard: "Manager Dashboard",
        escalations: "Escalations",

        // HomePage
        heroTitle: "Empowering Villages Through Digital Governance",
        heroSubtitle: "A modern platform for citizens and administrators to connect, manage, and grow.",
        loginCitizen: "Login as Citizen",
        loginAdmin: "Login as Admin",
        loginDepartment: "Login as Department",
        loginManager: "Login as Manager",
        aboutTitle: "About the Project",
        aboutDescription: "E-Gram Panchayat is a digital initiative to streamline village-level governance...",
        featuresTitle: "Features",
        featureLogin: "Secure Login & Registration",
        featureDashboard: "Admin Dashboard for Panchayat Staff",
        featureRequests: "Citizen Service Requests",
        featureNotifications: "Real-time Notifications",
        featureMobile: "Mobile-Friendly Design",
        contactTitle: "Contact",
        contactSubtitle: "Have questions or feedback?",
        contactName: "Name",
        contactEmail: "Email",
        contactMessage: "Message",
        contactSubmit: "Submit",
        footerRights: "All rights reserved.",
        services: "Services",
        quickTitle: "Quick Services",
        quickSubtitle: "Apply for requests, view status",
        quickDescription: "Citizen login gives access to request tracking, grievance submission, and personalized notifications.",

        announcementsTitle: "Announcements",
        announcementsSubtitle: "Important updates",
        announcementsDescription: "Notifications appear on the homepage. Click to view details (login required).",

        localTitle: "Local Info",
        localSubtitle: "Panchayat office & timings",
        localDescription: "{{name}} • {{location}}",
          "projectVideoTitle": "Empowering Residency System: See It in Action! 🚀",
  "projectVideoSubtitle": "A quick review of how our platform facilitates complaint management and transparency.",
  "videoNotSupported": "Your browser does not support the video tag.",
  "citizenFocusTitle": "Citizen Focus:",
  "citizenFocusDesc": "Easy login and grievance selection (Water, Electricity, etc.).",
  "adminControlTitle": "Admin Control:",
  "adminControlDesc": "Complete command center to track all complaints (Pending/Completed).",
  "transparencyTitle": "Transparency:",
  "transparencyDesc": "Statistics dashboard shows visual data on community issues.",

        "notification": {
  "title": "Important Update",
  "message": "👷 Workers are urgently needed to support community services. Join now and make a difference!",
  "loginPrompt": "Login as Worker",
  "detailsTitle": "Worker Opportunities",
  "detailsMessage": "You are logged in. Check your dashboard for assigned tasks and updates.",
  "closeLabel": "Close notification"
},

    //Features 
    "featuresTitle": "Key Features",
    "featureComplaints": "Complaint Management",
    "featureComplaintsDesc": "Citizens can submit complaints, track their status, and receive email notifications.",
    "featureStatistics": "Monthly Statistics",
    "featureStatisticsDesc": "Admins can view monthly complaint breakdowns with charts and tables.",
    "featurePublicInfo": "Public Information",
    "featurePublicInfoDesc": "Provides citizens with access to ministers, schemes, events, and Panchayat details.",
    "featureMultilingual": "Multilingual Support",
    "featureMultilingualDesc": "Supports English, Hindi, and Kannada for inclusivity.",

        //Notification
        "title": "New Notification",
    "message": "A new scheme has been announced for farmers.",
    "closeLabel": "Close notification",
    "loginPrompt": "Login or Register to view",
    "detailsTitle": "Details",
    "detailsMessage": "Health Scheme 2025 is now active. Apply at the Panchayat office.",

        // PublicInfoPage
  "publicInfo": {
    "title": "Public Information",
    "subtitle": "Ministers visits, schemes, events and Panchayat details — visible to everyone",
    "searchPlaceholder": "Search schemes, events, ministers...",
    "ministersTitle": "Ministers Visits",
    "ministersSubtitle": "Latest schedule",
    "schemesTitle": "Schemes",
    "schemesSubtitle": "Ongoing & new",
    "eligibility": "Eligibility",
    "deadline": "Deadline",
    "contact": "Contact",
    "applyNow": "Apply Now",
    "eventsTitle": "Events",
    "eventsSubtitle": "Upcoming",
    "date": "Date",
    "organizer": "Organizer",
    "registration": "Registration",
    "officeBearers": "Office Bearers",
    "quickTitle": "Quick Links",
    "quickSchemes": "View Schemes",
    "quickEvents": "Upcoming Events",
    "detailHeading": "Detail: {{detail}}",
    "detailQuick": "Quick Services details: birth/death certificates, grievance submission, KYC, etc.",
    "detailAnnouncements": "Announcements details: recent notifications and how to view them (login required for full details).",
    "detailLocal": "Panchayat contact details, office timings and quick links.",
    "venue": "Venue",
  "purpose": "Purpose",
  "contact": "Contact",
  "panchayatName": "Gram Panchayat XYZ",
    "panchayatLocation": "Gadag, Karnataka",
  "ministerA": {
    "purpose": "Review of health initiatives"
  },
  "ministerB": {
    "purpose": "Launch of education scheme"
  },
   "quickTitle": "Quick Services",
    "quickSubtitle": "Apply for requests, view status",
    "quickDescription": "Citizen login gives access to request tracking, grievance submission, and personalized notifications.",
    "announcementsTitle": "Announcements",
    "announcementsSubtitle": "Important updates",
    "announcementsDescription": "Notifications appear on the homepage. Click to view details (login required).",
    "localTitle": "Local Info",
    "localSubtitle": "Panchayat office & timings",
    "localDescription": "{{name}} • {{location}}"
  },

  //feedback
  "giveFeedback": "Give Feedback",
  "enterFeedback": "Enter your feedback here...",
  "submitFeedback": "Submit Feedback",


        // Login/Register/Signup/VerifyOtp
        emailOrPhone: "Email or Phone",
        password: "Password",
        loginError: "Login error",
        name: "Name",
        email: "Email",
        otpSent: "OTP sent to your email",
        error: "Error",
        enterOtp: "Enter OTP",
        otpPlaceholder: "6-digit OTP",
        verify: "Verify",
        otpVerified: "OTP verified! Redirecting to login.",
        otpError: "OTP error",
        signup: "Signup",
        accountVerified: "Account verified! You can now login.",
        invalidCredentials: "Invalid credentials",

        // KYC
        completeKYC: "Complete KYC",
        aadhaarNumber: "Aadhaar number",
        state: "State",
        town: "Town",
        pinCode: "PIN code",
        streetArea: "Street / Area",
        submitKYC: "Submit KYC",
        loadingKYC: "Loading KYC details...",
        kycCompleted: "KYC completed",
        kycError: "KYC error",

        // MyComplaints
        noComplaintsYet: "No complaints yet",
        address: "Address",
        raised: "Raised",

        // NotFound
        pageNotFound: "404 - Page Not Found",

        // RaiseComplaint
        shortTitle: "Short title",
        describeIssue: "Describe the issue",
        problemAddress: "Address of the problem",
        captureLocation: "Capture Device Location",
        captured: "Captured",
        submitComplaint: "Submit Complaint",
        geoNotSupported: "Geolocation not supported. Please enter address manually.",
        locationCaptured: "Location captured from device.",
        locationError: "Unable to get location. Please enter address manually.",
        noLocationConfirm: "No device location captured. Submit with manual address only?",
        complaintSubmitted: "Complaint submitted",
        complaintError: "Error submitting complaint",

        // GrievanceSelection
        selectGrievance: "Select Grievance",
        selectGrievanceInstruction: "Please select your grievance to continue",
        waterIssue: "Water Issue",
        electricityIssue: "Electricity Issue",
        roadDamage: "Road Damage",
        streetlightsIssue: "Streetlights Issue",
        sanitation: "Sanitation",
        health: "Health",
        education: "Education",
        wasteManagement: "Waste Management",
        publicSafety: "Public Safety",
        other: "Other",

        // AdminComplaints
        loadingComplaints: "Loading complaints...",
        complaintsManagement: "Complaints Management",
        update: "Update",
        pending: "Pending",
        accepted: "Accepted",
        rejected: "Rejected",
        completed: "Completed",

        // AdminDashboard
        allComplaints: "All Complaints",
        filterComplaints: "Filter Complaints",
        userName: "User Name",
        allStatus: "All Status",
        apply: "Apply",
        reset: "Reset",
        problemAddress: "Problem Address",
        deviceLocation: "Device Location",
        action: "Action",
        errorFetchingComplaints: "Error fetching complaints",
        addressNotFound: "Address not found",
        reverseGeocodeError: "Reverse geocode error",

        // AdminUsers
        loadingUsers: "Loading users...",
        allUsers: "All Users",
        filterUsers: "Filter Users",
        searchByName: "Search by Name",
        searchByEmail: "Search by Email",
        searchByPhone: "Search by Phone",
        allKyc: "All KYC",
        kycStatus: "KYC Status",
        details: "Details",
        kycCompleted: "KYC Completed",
        yes: "Yes",
        no: "No",
        aadhaarNumber: "Aadhaar Number",
        totalComplaints: "Total Complaints",
        close: "Close"
      },

      //Worker
      "loginWorker": "Login as Worker",
      "workerDashboard": "Worker Dashboard",
      "assignedComplaints": "Assigned Complaints",
      "worker": "Worker"
    },

    hi: {
      translation: {
        // Common
        welcome: "ई-ग्राम पंचायत में आपका स्वागत है",
        projectTitle: "निवास सशक्तिकरण",
        home: "होम",
        register: "रजिस्टर",
        login: "लॉगिन",
        logout: "लॉगआउट",
        admin: "प्रशासक",
        Worker: "श्रमिक",
        dashboard: "डैशबोर्ड",
        complaints: "शिकायतें",
        users: "उपयोगकर्ता",
        raiseComplaint: "शिकायत दर्ज करें",
        myComplaints: "मेरी शिकायतें",
        kyc: "केवाईसी",
        PublicInfo: "सार्वजनिक जानकारी",
        workerDashboard: "श्रमिक डैशबोर्ड",
        assignedComplaints: "सौंपे गए शिकायतें",
        profile: "प्रोफ़ाइल",
        managerDashboard: "प्रबंधक डैशबोर्ड",
        escalations: "एस्कलेशन",
        
        //feedback 
        "giveFeedback": "प्रतिक्रिया दें",
        "enterFeedback": "अपनी प्रतिक्रिया यहाँ लिखें...",
        "submitFeedback": "प्रतिक्रिया जमा करें",

        // HomePage
        heroTitle: "डिजिटल शासन के माध्यम से गांवों को सशक्त बनाना",
        heroSubtitle: "नागरिकों और प्रशासकों को जोड़ने, प्रबंधित करने और बढ़ने के लिए एक आधुनिक मंच।",
        loginCitizen: "नागरिक के रूप में लॉगिन करें",
        loginAdmin: "प्रशासक के रूप में लॉगिन करें",
        loginDepartment: "विभाग के रूप में लॉगिन करें",
        loginWorker: "श्रमिक के रूप में लॉगिन करें",
        loginManager: "प्रबंधक के रूप में लॉगिन करें",
        Statistics:  "आंकड़े",
        aboutTitle: "परियोजना के बारे में",
        aboutDescription: "ई-ग्राम पंचायत एक डिजिटल पहल है जो गांव स्तर पर शासन को सरल बनाती है...",
        featuresTitle: "विशेषताएँ",
        featureLogin: "सुरक्षित लॉगिन और पंजीकरण",
        featureDashboard: "पंचायत स्टाफ के लिए एडमिन डैशबोर्ड",
        featureRequests: "नागरिक सेवा अनुरोध",
        featureNotifications: "रीयल-टाइम सूचनाएं",
        featureMobile: "मोबाइल-फ्रेंडली डिज़ाइन",
        contactTitle: "संपर्क करें",
        contactSubtitle: "क्या आपके पास प्रश्न या सुझाव हैं?",
        contactName: "नाम",
        contactEmail: "ईमेल",
        contactMessage: "संदेश",
        contactSubmit: "सबमिट करें",
        footerRights: "सभी अधिकार सुरक्षित।",
        services: "सेवाएँ",
        quickTitle: "त्वरित सेवाएँ",
        quickSubtitle: "अनुरोध करें, स्थिति देखें",
        quickDescription: "नागरिक लॉगिन से अनुरोध ट्रैकिंग, शिकायत जमा करने और व्यक्तिगत सूचनाओं तक पहुँच मिलती है।",

        announcementsTitle: "घोषणाएँ",
        announcementsSubtitle: "महत्वपूर्ण अपडेट",
        announcementsDescription: "सूचनाएँ होमपेज पर दिखाई देती हैं। विवरण देखने के लिए क्लिक करें (लॉगिन आवश्यक)।",

        localTitle: "स्थानीय जानकारी",
        localSubtitle: "पंचायत कार्यालय और समय",
        localDescription: "{{name}} • {{location}}",
  "projectVideoTitle": "निवासी प्रणाली को सशक्त बनाना: इसे क्रियान्वयन में देखें! 🚀",
  "projectVideoSubtitle": "हमारा प्लेटफ़ॉर्म शिकायत प्रबंधन और पारदर्शिता को कैसे आसान बनाता है इसका संक्षिप्त अवलोकन।",
  "videoNotSupported": "आपका ब्राउज़र वीडियो टैग को सपोर्ट नहीं करता।",
  "citizenFocusTitle": "नागरिक केंद्रित:",
  "citizenFocusDesc": "सरल लॉगिन और शिकायत चयन (पानी, बिजली आदि)।",
  "adminControlTitle": "प्रशासनिक नियंत्रण:",
  "adminControlDesc": "सभी शिकायतों को ट्रैक करने के लिए पूर्ण कमांड सेंटर (लंबित/पूर्ण)।",
  "transparencyTitle": "पारदर्शिता:",
  "transparencyDesc": "सांख्यिकी डैशबोर्ड समुदाय की समस्याओं पर दृश्य डेटा दिखाता है।",

        "notification": {
  "title": "महत्वपूर्ण सूचना",
  "message": "👷 समुदाय सेवाओं का समर्थन करने के लिए तुरंत श्रमिकों की आवश्यकता है। अभी जुड़ें और बदलाव लाएँ!",
  "loginPrompt": "श्रमिक के रूप में लॉगिन करें",
  "detailsTitle": "श्रमिक अवसर",
  "detailsMessage": "आप लॉगिन कर चुके हैं। अपने डैशबोर्ड में सौंपे गए कार्य और अपडेट देखें।",
  "closeLabel": "सूचना बंद करें"
},
   
  //Features
  "featuresTitle": "मुख्य विशेषताएँ",
    "featureComplaints": "शिकायत प्रबंधन",
    "featureComplaintsDesc": "नागरिक शिकायत दर्ज कर सकते हैं, उसकी स्थिति ट्रैक कर सकते हैं और ईमेल सूचनाएँ प्राप्त कर सकते हैं।",
    "featureStatistics": "मासिक आँकड़े",
    "featureStatisticsDesc": "प्रशासक मासिक शिकायतों का विवरण चार्ट और तालिकाओं में देख सकते हैं।",
    "featurePublicInfo": "सार्वजनिक जानकारी",
    "featurePublicInfoDesc": "नागरिकों को मंत्रियों, योजनाओं, कार्यक्रमों और पंचायत विवरण तक पहुँच प्रदान करता है।",
    "featureMultilingual": "बहुभाषी समर्थन",
    "featureMultilingualDesc": "समावेशिता के लिए अंग्रेज़ी, हिंदी और कन्नड़ का समर्थन करता है।",

        //PublicInfo
  "publicInfo": {
    "title": "सार्वजनिक जानकारी",
    "subtitle": "मंत्रियों की यात्राएँ, योजनाएँ, कार्यक्रम और पंचायत विवरण — सभी के लिए उपलब्ध",
    "searchPlaceholder": "योजनाएँ, कार्यक्रम, मंत्री खोजें...",
    "ministersTitle": "मंत्रियों की यात्राएँ",
    "ministersSubtitle": "नवीनतम कार्यक्रम",
    "schemesTitle": "योजनाएँ",
    "schemesSubtitle": "चल रही और नई",
    "eligibility": "पात्रता",
    "deadline": "अंतिम तिथि",
    "contact": "संपर्क",
    "applyNow": "अभी आवेदन करें",
    "eventsTitle": "कार्यक्रम",
    "eventsSubtitle": "आगामी",
    "date": "तारीख",
    "organizer": "आयोजक",
    "registration": "पंजीकरण",
    "officeBearers": "पदाधिकारी",
    "quickTitle": "त्वरित लिंक",
    "quickSchemes": "योजनाएँ देखें",
    "quickEvents": "आगामी कार्यक्रम",
    "detailHeading": "विवरण: {{detail}}",
    "detailQuick": "त्वरित सेवाओं का विवरण: जन्म/मृत्यु प्रमाणपत्र, शिकायत दर्ज करना, केवाईसी आदि।",
    "detailAnnouncements": "घोषणाओं का विवरण: हाल की सूचनाएँ और उन्हें कैसे देखें (पूर्ण विवरण के लिए लॉगिन आवश्यक)।",
    "detailLocal": "पंचायत संपर्क विवरण, कार्यालय समय और त्वरित लिंक।",
    "venue": "स्थान",
  "purpose": "उद्देश्य",
  "contact": "संपर्क",
   "panchayatName": "ग्राम पंचायत XYZ",
    "panchayatLocation": "गडग, कर्नाटक",
  "ministerA": {
    "purpose": "स्वास्थ्य पहलों की समीक्षा"
  },
  "ministerB": {
    "purpose": "शिक्षा योजना का शुभारंभ"
  },
  "quickTitle": "त्वरित सेवाएँ",
    "quickSubtitle": "अनुरोधों के लिए आवेदन करें, स्थिति देखें",
    "quickDescription": "नागरिक लॉगिन से अनुरोध ट्रैकिंग, शिकायत दर्ज करना और व्यक्तिगत सूचनाओं तक पहुँच मिलती है।",
    "announcementsTitle": "घोषणाएँ",
    "announcementsSubtitle": "महत्वपूर्ण अपडेट",
    "announcementsDescription": "सूचनाएँ होमपेज पर दिखाई देती हैं। विवरण देखने के लिए क्लिक करें (लॉगिन आवश्यक)।",
    "localTitle": "स्थानीय जानकारी",
    "localSubtitle": "पंचायत कार्यालय और समय",
    "localDescription": "{{name}} • {{location}}"
  },
        // Login/Register/Signup/VerifyOtp
        emailOrPhone: "ईमेल या फोन",
        password: "पासवर्ड",
        loginError: "लॉगिन त्रुटि",
        name: "नाम",
        email: "ईमेल",
        otpSent: "आपके ईमेल पर OTP भेजा गया",
        error: "त्रुटि",
        enterOtp: "OTP दर्ज करें",
        otpPlaceholder: "6-अंकीय OTP",
        verify: "सत्यापित करें",
        otpVerified: "OTP सत्यापित! लॉगिन पर रीडायरेक्ट किया जा रहा है।",
        otpError: "OTP त्रुटि",
        signup: "साइनअप",
        accountVerified: "खाता सत्यापित! अब आप लॉगिन कर सकते हैं।",
        invalidCredentials: "अमान्य प्रमाण-पत्र",

        // KYC
        completeKYC: "केवाईसी पूरा करें",
        aadhaarNumber: "आधार नंबर",
        state: "राज्य",
        town: "कस्बा",
        pinCode: "पिन कोड",
        streetArea: "गली / क्षेत्र",
        submitKYC: "केवाईसी सबमिट करें",
        loadingKYC: "केवाईसी विवरण लोड हो रहे हैं...",
        kycCompleted: "केवाईसी पूर्ण",
        kycError: "केवाईसी त्रुटि",

        // MyComplaints
        noComplaintsYet: "अभी तक कोई शिकायत नहीं",
        address: "पता",
        raised: "दर्ज की गई",

        // NotFound
        pageNotFound: "404 - पेज नहीं मिला",

        // RaiseComplaint
        shortTitle: "संक्षिप्त शीर्षक",
        describeIssue: "समस्या का वर्णन करें",
        problemAddress: "समस्या का पता",
        captureLocation: "डिवाइस स्थान कैप्चर करें",
        captured: "कैप्चर किया गया",
        submitComplaint: "शिकायत सबमिट करें",
        geoNotSupported: "जियोलोकेशन समर्थित नहीं है। कृपया पता मैन्युअली दर्ज करें।",
        locationCaptured: "डिवाइस से स्थान कैप्चर किया गया।",
        locationError: "स्थान प्राप्त करने में असमर्थ। कृपया पता मैन्युअली दर्ज करें।",
        noLocationConfirm: "कोई डिवाइस स्थान कैप्चर नहीं हुआ। केवल मैन्युअल पता के साथ सबमिट करें?",
        complaintSubmitted: "शिकायत सबमिट की गई",
        complaintError: "शिकायत सबमिट करने में त्रुटि",

        // GrievanceSelection
        selectGrievance: "शिकायत चुनें",
        selectGrievanceInstruction: "कृपया आगे बढ़ने के लिए अपनी शिकायत चुनें",
        waterIssue: "पानी की समस्या",
        electricityIssue: "बिजली की समस्या",
        roadDamage: "सड़क क्षति",
        streetlightsIssue: "स्ट्रीटलाइट समस्या",
        sanitation: "स्वच्छता",
        health: "स्वास्थ्य",
        education: "शिक्षा",
        wasteManagement: "कचरा प्रबंधन",
        publicSafety: "सार्वजनिक सुरक्षा",
        other: "अन्य",

        // AdminComplaints
        loadingComplaints: "शिकायतें लोड हो रही हैं...",
        complaintsManagement: "शिकायत प्रबंधन",
        update: "अपडेट",
        pending: "लंबित",
        accepted: "स्वीकृत",
        rejected: "अस्वीकृत",
        completed: "पूर्ण",

        // AdminDashboard
        allComplaints: "सभी शिकायतें",
        filterComplaints: "शिकायतें फ़िल्टर करें",
        userName: "उपयोगकर्ता नाम",
        allStatus: "सभी स्थिति",
        apply: "लागू करें",
        reset: "रीसेट",
        problemAddress: "समस्या का पता",
        deviceLocation: "डिवाइस स्थान",
        action: "कार्रवाई",
        errorFetchingComplaints: "शिकायतें प्राप्त करने में त्रुटि",
        addressNotFound: "पता नहीं मिला",
        reverseGeocodeError: "रिवर्स जियोकोड त्रुटि",

        // AdminUsers
        loadingUsers: "उपयोगकर्ता लोड हो रहे हैं...",
        allUsers: "सभी उपयोगकर्ता",
        filterUsers: "उपयोगकर्ता फ़िल्टर करें",
        searchByName: "नाम से खोजें",
        searchByEmail: "ईमेल से खोजें",
        searchByPhone: "फ़ोन से खोजें",
        allKyc: "सभी KYC",
        kycStatus: "KYC स्थिति",
        details: "विवरण",
        kycCompleted: "KYC पूर्ण",
        yes: "हाँ",
        no: "नहीं",
        aadhaarNumber: "आधार नंबर",
        totalComplaints: "कुल शिकायतें",
        close: "बंद करें",

        //AdminUsers
        adminLogin: "प्रशासक लॉगिन",
        email: "ईमेल",
        password: "पासवर्ड",
        login: "लॉगिन",
        invalidCredentials: "अमान्य प्रमाण-पत्र",
      }
    },

        kn: {
      translation: {
        // Common
        welcome: "ಇ-ಗ್ರಾಮ ಪಂಚಾಯತ್‌ಗೆ ಸ್ವಾಗತ",
        projectTitle: "ನಿವಾಸ ಸಬಲೀಕರಣ",
        home: "ಮುಖಪುಟ",
        register: "ನೋಂದಣಿ",
        login: "ಲಾಗಿನ್",
        logout: "ಲಾಗ್‌ಔಟ್",
        admin: "ನಿರ್ವಾಹಕ",
        Worker: "ಕಾರ್ಮಿಕ",
        dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
        complaints: "ದೂರುಗಳು",
        users: "ಬಳಕೆದಾರರು",
        raiseComplaint: "ದೂರು ದಾಖಲಿಸಿ",
        myComplaints: "ನನ್ನ ದೂರುಗಳು",
        kyc: "ಕೆವೈಸಿ",
        PublicInfo: "ಸಾರ್ವಜನಿಕ ಮಾಹಿತಿ",
        workerDashboard: "ಕಾರ್ಮಿಕ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
        assignedComplaints: "ನಿಯೋಜಿತ ದೂರುಗಳು",
        profile: "ಪ್ರೊಫೈಲ್",
        managerDashboard: "ವ್ಯವಸ್ಥಾಪಕರ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
        escalations: "ಮೇಲ್ಮನವಿಗಳು",

        // HomePage
        heroTitle: "ಡಿಜಿಟಲ್ ಆಡಳಿತದ ಮೂಲಕ ಗ್ರಾಮಗಳನ್ನು ಸಬಲೀಕರಿಸುವುದು",
        heroSubtitle: "ನಾಗರಿಕರು ಮತ್ತು ಆಡಳಿತಗಾರರು ಸಂಪರ್ಕಿಸಲು, ನಿರ್ವಹಿಸಲು ಮತ್ತು ಬೆಳೆಯಲು ಆಧುನಿಕ ವೇದಿಕೆ.",
        loginCitizen: "ನಾಗರಿಕರಾಗಿ ಲಾಗಿನ್ ಮಾಡಿ",
        loginAdmin: "ನಿರ್ವಾಹಕರಾಗಿ ಲಾಗಿನ್ ಮಾಡಿ",
        loginDepartment: "ಇಲಾಖೆಯಾಗಿ ಲಾಗಿನ್ ಮಾಡಿ",
        loginWorker: "ಕಾರ್ಮಿಕರಾಗಿ ಲಾಗಿನ್ ಮಾಡಿ",
        loginManager: "ವ್ಯವಸ್ಥಾಪಕರಾಗಿ ಲಾಗಿನ್ ಮಾಡಿ",
        Statistics:  "ಅಂಕಿಅಂಶಗಳು",
        aboutTitle: "ಯೋಜನೆಯ ಬಗ್ಗೆ",
        aboutDescription: "ಇ-ಗ್ರಾಮ ಪಂಚಾಯತ್ ಗ್ರಾಮ ಮಟ್ಟದ ಆಡಳಿತವನ್ನು ಸುಗಮಗೊಳಿಸುವ ಡಿಜಿಟಲ್ ಉಪಕ್ರಮವಾಗಿದೆ...",
        featuresTitle: "ವೈಶಿಷ್ಟ್ಯಗಳು",
        featureLogin: "ಸುರಕ್ಷಿತ ಲಾಗಿನ್ ಮತ್ತು ನೋಂದಣಿ",
        featureDashboard: "ಪಂಚಾಯತ್ ಸಿಬ್ಬಂದಿಗಾಗಿ ಆಡಳಿತ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
        featureRequests: "ನಾಗರಿಕ ಸೇವಾ ವಿನಂತಿಗಳು",
        featureNotifications: "ರಿಯಲ್-ಟೈಮ್ ಅಧಿಸೂಚನೆಗಳು",
        featureMobile: "ಮೊಬೈಲ್ ಸ್ನೇಹಿ ವಿನ್ಯಾಸ",
        contactTitle: "ಸಂಪರ್ಕ",
        contactSubtitle: "ಪ್ರಶ್ನೆಗಳು ಅಥವಾ ಪ್ರತಿಕ್ರಿಯೆಗಳಿವೆಯೇ?",
        contactName: "ಹೆಸರು",
        contactEmail: "ಇಮೇಲ್",
        contactMessage: "ಸಂದೇಶ",
        contactSubmit: "ಸಲ್ಲಿಸು",
        footerRights: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
        services: "ಸೇವೆಗಳು",
        quickTitle: "ತ್ವರಿತ ಸೇವೆಗಳು",
        quickSubtitle: "ಅರ್ಜಿಗಳನ್ನು ಸಲ್ಲಿಸಿ, ಸ್ಥಿತಿ ನೋಡಿ",
        quickDescription: "ನಾಗರಿಕ ಲಾಗಿನ್ ಮೂಲಕ ವಿನಂತಿ ಟ್ರ್ಯಾಕಿಂಗ್, ದೂರು ಸಲ್ಲಿಕೆ ಮತ್ತು ವೈಯಕ್ತಿಕ ಅಧಿಸೂಚನೆಗಳನ್ನು ಪಡೆಯಬಹುದು.",

        announcementsTitle: "ಪ್ರಕಟಣೆಗಳು",
        announcementsSubtitle: "ಮುಖ್ಯ ನವೀಕರಣಗಳು",
        announcementsDescription: "ಅಧಿಸೂಚನೆಗಳು ಮುಖಪುಟದಲ್ಲಿ ಕಾಣಿಸುತ್ತವೆ. ವಿವರಗಳನ್ನು ನೋಡಲು ಕ್ಲಿಕ್ ಮಾಡಿ (ಲಾಗಿನ್ ಅಗತ್ಯ).",

        localTitle: "ಸ್ಥಳೀಯ ಮಾಹಿತಿ",
        localSubtitle: "ಪಂಚಾಯತ್ ಕಚೇರಿ ಮತ್ತು ಸಮಯ",
        localDescription: "{{name}} • {{location}}",
  "projectVideoTitle": "ನಿವಾಸಿ ವ್ಯವಸ್ಥೆಯನ್ನು ಶಕ್ತಗೊಳಿಸುವುದು: ಕಾರ್ಯದಲ್ಲಿ ನೋಡಿ! 🚀",
  "projectVideoSubtitle": "ನಮ್ಮ ವೇದಿಕೆ ದೂರು ನಿರ್ವಹಣೆ ಮತ್ತು ಪಾರದರ್ಶಕತೆಯನ್ನು ಹೇಗೆ ಸುಗಮಗೊಳಿಸುತ್ತದೆ ಎಂಬುದರ ಚಿಕ್ಕ ವಿಮರ್ಶೆ.",
  "videoNotSupported": "ನಿಮ್ಮ ಬ್ರೌಸರ್ ವೀಡಿಯೊ ಟ್ಯಾಗ್ ಅನ್ನು ಬೆಂಬಲಿಸುವುದಿಲ್ಲ.",
  "citizenFocusTitle": "ನಾಗರಿಕ ಕೇಂದ್ರೀಕರಣ:",
  "citizenFocusDesc": "ಸರಳ ಲಾಗಿನ್ ಮತ್ತು ದೂರು ಆಯ್ಕೆ (ನೀರು, ವಿದ್ಯುತ್ ಇತ್ಯಾದಿ).",
  "adminControlTitle": "ನಿರ್ವಾಹಕ ನಿಯಂತ್ರಣ:",
  "adminControlDesc": "ಎಲ್ಲಾ ದೂರುಗಳನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಲು ಸಂಪೂರ್ಣ ಕಮಾಂಡ್ ಸೆಂಟರ್ (ಬಾಕಿ/ಪೂರ್ಣಗೊಂಡ).",
  "transparencyTitle": "ಪಾರದರ್ಶಕತೆ:",
  "transparencyDesc": "ಸಂಖ್ಯಾ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಸಮುದಾಯ ಸಮಸ್ಯೆಗಳ ದೃಶ್ಯ ಡೇಟಾವನ್ನು ತೋರಿಸುತ್ತದೆ.",
        //Features
        "featuresTitle": "ಮುಖ್ಯ ವೈಶಿಷ್ಟ್ಯಗಳು",
    "featureComplaints": "ದೂರು ನಿರ್ವಹಣೆ",
    "featureComplaintsDesc": "ನಾಗರಿಕರು ದೂರುಗಳನ್ನು ಸಲ್ಲಿಸಿ, ಅವುಗಳ ಸ್ಥಿತಿಯನ್ನು (ಬಾಕಿ, ಅಂಗೀಕರಿಸಲಾಗಿದೆ, ತಿರಸ್ಕರಿಸಲಾಗಿದೆ, ಪೂರ್ಣಗೊಂಡಿದೆ) ಹಿಂಬಾಲಿಸಿ, ಇಮೇಲ್ ಸೂಚನೆಗಳನ್ನು ಪಡೆಯಬಹುದು.",
    "featureStatistics": "ಮಾಸಿಕ ಅಂಕಿಅಂಶಗಳು",
    "featureStatisticsDesc": "ನಿರ್ವಾಹಕರು ಮಾಸಿಕ ದೂರುಗಳ ವಿವರವನ್ನು ಚಾರ್ಟ್‌ಗಳು ಮತ್ತು ಪಟ್ಟಿಗಳ ಮೂಲಕ ವೀಕ್ಷಿಸಬಹುದು.",
    "featurePublicInfo": "ಸಾರ್ವಜನಿಕ ಮಾಹಿತಿ",
    "featurePublicInfoDesc": "ನಾಗರಿಕರಿಗೆ ಸಚಿವರು, ಯೋಜನೆಗಳು, ಕಾರ್ಯಕ್ರಮಗಳು ಮತ್ತು ಪಂಚಾಯತ್ ವಿವರಗಳಿಗೆ ಪ್ರವೇಶ ಒದಗಿಸುತ್ತದೆ.",
    "featureMultilingual": "ಬಹುಭಾಷಾ ಬೆಂಬಲ",
    "featureMultilingualDesc": "ಸಮಾವೇಶಕ್ಕಾಗಿ ಇಂಗ್ಲಿಷ್, ಹಿಂದಿ ಮತ್ತು ಕನ್ನಡವನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆ.",
        
        //Notification
       "notification": {
  "title": "ಮುಖ್ಯ ಮಾಹಿತಿ",
  "message": "👷 ಸಮುದಾಯ ಸೇವೆಗಳನ್ನು ಬೆಂಬಲಿಸಲು ತಕ್ಷಣ ಕಾರ್ಮಿಕರ ಅಗತ್ಯವಿದೆ. ಈಗ ಸೇರಿ ಮತ್ತು ಬದಲಾವಣೆ ತಂದುಕೊಳ್ಳಿ!",
  "loginPrompt": "ಕಾರ್ಮಿಕರಾಗಿ ಲಾಗಿನ್ ಮಾಡಿ",
  "detailsTitle": "ಕಾರ್ಮಿಕ ಅವಕಾಶಗಳು",
  "detailsMessage": "ನೀವು ಲಾಗಿನ್ ಆಗಿದ್ದೀರಿ. ನಿಯೋಜಿತ ಕೆಲಸಗಳು ಮತ್ತು ನವೀಕರಣಗಳನ್ನು ನಿಮ್ಮ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ನಲ್ಲಿ ಪರಿಶೀಲಿಸಿ.",
  "closeLabel": "ಅಧಿಸೂಚನೆ ಮುಚ್ಚಿ"
},

        //PublicInfo
  "publicInfo": {
    "title": "ಸಾರ್ವಜನಿಕ ಮಾಹಿತಿ",
    "subtitle": "ಮಂತ್ರಿಗಳ ಭೇಟಿಗಳು, ಯೋಜನೆಗಳು, ಕಾರ್ಯಕ್ರಮಗಳು ಮತ್ತು ಪಂಚಾಯತ್ ವಿವರಗಳು — ಎಲ್ಲರಿಗೂ ಲಭ್ಯ",
    "searchPlaceholder": "ಯೋಜನೆಗಳು, ಕಾರ್ಯಕ್ರಮಗಳು, ಮಂತ್ರಿಗಳನ್ನು ಹುಡುಕಿ...",
    "ministersTitle": "ಮಂತ್ರಿಗಳ ಭೇಟಿಗಳು",
    "ministersSubtitle": "ಇತ್ತೀಚಿನ ವೇಳಾಪಟ್ಟಿ",
    "schemesTitle": "ಯೋಜನೆಗಳು",
    "schemesSubtitle": "ನಡೆಯುತ್ತಿರುವ ಮತ್ತು ಹೊಸ",
    "eligibility": "ಅರ್ಹತೆ",
    "deadline": "ಕೊನೆಯ ದಿನಾಂಕ",
    "contact": "ಸಂಪರ್ಕ",
    "applyNow": "ಈಗ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ",
    "eventsTitle": "ಕಾರ್ಯಕ್ರಮಗಳು",
    "eventsSubtitle": "ಮುಂದಿನವು",
    "date": "ದಿನಾಂಕ",
    "organizer": "ಆಯೋಜಕರು",
    "registration": "ನೋಂದಣಿ",
    "officeBearers": "ಪದಾಧಿಕಾರಿಗಳು",
    "quickTitle": "ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು",
    "quickSchemes": "ಯೋಜನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    "quickEvents": "ಮುಂದಿನ ಕಾರ್ಯಕ್ರಮಗಳು",
    "detailHeading": "ವಿವರ: {{detail}}",
    "detailQuick": "ತ್ವರಿತ ಸೇವೆಗಳ ವಿವರಗಳು: ಜನನ/ಮರಣ ಪ್ರಮಾಣಪತ್ರಗಳು, ದೂರು ಸಲ್ಲಿಕೆ, KYC ಇತ್ಯಾದಿ.",
    "detailAnnouncements": "ಘೋಷಣೆಗಳ ವಿವರಗಳು: ಇತ್ತೀಚಿನ ಅಧಿಸೂಚನೆಗಳು ಮತ್ತು ಅವನ್ನು ಹೇಗೆ ವೀಕ್ಷಿಸಬೇಕು (ಪೂರ್ಣ ವಿವರಗಳಿಗೆ ಲಾಗಿನ್ ಅಗತ್ಯ).",
    "detailLocal": "ಪಂಚಾಯತ್ ಸಂಪರ್ಕ ವಿವರಗಳು, ಕಚೇರಿ ಸಮಯ ಮತ್ತು ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು.",
    "venue": "ಸ್ಥಳ",
  "purpose": "ಉದ್ದೇಶ",
  "contact": "ಸಂಪರ್ಕ",
   "panchayatName": "ಗ್ರಾಮ ಪಂಚಾಯತ್ XYZ",
   "panchayatLocation": "ಗದಗ, ಕರ್ನಾಟಕ",
   "schemes": {
    "healthScheme": "ಆರೋಗ್ಯ ಯೋಜನೆ - ಎಲ್ಲಾ ನಿವಾಸಿಗಳಿಗೆ ಉಚಿತ ಆರೋಗ್ಯ ತಪಾಸಣೆ",
    "educationScheme": "ಶಿಕ್ಷಣ ಯೋಜನೆ - ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ವಿದ್ಯಾರ್ಥಿವೇತನ",
    "agricultureScheme": "ಕೃಷಿ ಯೋಜನೆ - ರೈತರಿಗೆ ಸಹಾಯಧನ ಮತ್ತು ತರಬೇತಿ"
  },
  "ministerA": {
    "purpose": "ಆರೋಗ್ಯ ಕಾರ್ಯಕ್ರಮಗಳ ಪರಿಶೀಲನೆ"
  },
  "ministerB": {
    "purpose": "ಶಿಕ್ಷಣ ಯೋಜನೆಯ ಪ್ರಾರಂಭ"
  },
    "quickTitle": "ತ್ವರಿತ ಸೇವೆಗಳು",
    "quickSubtitle": "ಅರ್ಜಿ ಸಲ್ಲಿಸಿ, ಸ್ಥಿತಿಯನ್ನು ವೀಕ್ಷಿಸಿ",
    "quickDescription": "ನಾಗರಿಕ ಲಾಗಿನ್ ಮೂಲಕ ವಿನಂತಿ ಟ್ರ್ಯಾಕಿಂಗ್, ದೂರು ಸಲ್ಲಿಕೆ ಮತ್ತು ವೈಯಕ್ತಿಕ ಅಧಿಸೂಚನೆಗಳನ್ನು ಪಡೆಯಬಹುದು.",
    "announcementsTitle": "ಅಧಿಸೂಚನೆಗಳು",
    "announcementsSubtitle": "ಮುಖ್ಯ ನವೀಕರಣಗಳು",
    "announcementsDescription": "ಅಧಿಸೂಚನೆಗಳು ಮುಖಪುಟದಲ್ಲಿ ಕಾಣಿಸುತ್ತವೆ. ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಕ್ಲಿಕ್ ಮಾಡಿ (ಲಾಗಿನ್ ಅಗತ್ಯ).",
    "localTitle": "ಸ್ಥಳೀಯ ಮಾಹಿತಿ",
    "localSubtitle": "ಪಂಚಾಯತ್ ಕಚೇರಿ ಮತ್ತು ಸಮಯ",
     "panchayatName": "ಗ್ರಾಮ ಪಂಚಾಯತ್ XYZ",
    "panchayatLocation": "ಗದಗ, ಕರ್ನಾಟಕ",
    "localDescription": "{{name}} • {{location}}"

  },

        // Login/Register/Signup/VerifyOtp
        emailOrPhone: "ಇಮೇಲ್ ಅಥವಾ ಫೋನ್",
        password: "ಪಾಸ್ವರ್ಡ್",
        loginError: "ಲಾಗಿನ್ ದೋಷ",
        name: "ಹೆಸರು",
        email: "ಇಮೇಲ್",
        otpSent: "ನಿಮ್ಮ ಇಮೇಲ್‌ಗೆ OTP ಕಳುಹಿಸಲಾಗಿದೆ",
        error: "ದೋಷ",
        enterOtp: "OTP ನಮೂದಿಸಿ",
        otpPlaceholder: "6-ಅಂಕಿ OTP",
        verify: "ದೃಢೀಕರಿಸಿ",
        otpVerified: "OTP ದೃಢೀಕರಿಸಲಾಗಿದೆ! ಲಾಗಿನ್‌ಗೆ ಮರುನಿರ್ದೇಶಿಸಲಾಗುತ್ತಿದೆ.",
        otpError: "OTP ದೋಷ",
        signup: "ಸೈನ್ ಅಪ್",
        accountVerified: "ಖಾತೆ ಪರಿಶೀಲಿಸಲಾಗಿದೆ! ನೀವು ಈಗ ಲಾಗಿನ್ ಮಾಡಬಹುದು.",
        invalidCredentials: "ಅಮಾನ್ಯ ದಾಖಲೆಗಳು",

        // KYC
        completeKYC: "ಕೆವೈಸಿ ಪೂರ್ಣಗೊಳಿಸಿ",
        aadhaarNumber: "ಆಧಾರ್ ಸಂಖ್ಯೆ",
        state: "ರಾಜ್ಯ",
        town: "ಪಟ್ಟಣ",
        pinCode: "ಪಿನ್ ಕೋಡ್",
        streetArea: "ರಸ್ತೆ / ಪ್ರದೇಶ",
        submitKYC: "ಕೆವೈಸಿ ಸಲ್ಲಿಸಿ",
        loadingKYC: "ಕೆವೈಸಿ ವಿವರಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
        kycCompleted: "ಕೆವೈಸಿ ಪೂರ್ಣಗೊಂಡಿದೆ",
        kycError: "ಕೆವೈಸಿ ದೋಷ",
        
        // MyComplaints
        noComplaintsYet: "ಇನ್ನೂ ಯಾವುದೇ ದೂರುಗಳಿಲ್ಲ",
        address: "ವಿಳಾಸ",
        raised: "ಎತ್ತಲಾಗಿದೆ",

        //feedback 
        "giveFeedback": "ಪ್ರತಿಕ್ರಿಯೆ ನೀಡಿ",
        "enterFeedback": "ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ಇಲ್ಲಿ ಬರೆಯಿರಿ...",
        "submitFeedback": "ಪ್ರತಿಕ್ರಿಯೆ ಸಲ್ಲಿಸಿ",

        // NotFound
        pageNotFound: "404 - ಪುಟ ಕಂಡುಬಂದಿಲ್ಲ",

        // RaiseComplaint
        shortTitle: "ಸಂಕ್ಷಿಪ್ತ ಶೀರ್ಷಿಕೆ",
        describeIssue: "ಸಮಸ್ಯೆಯನ್ನು ವಿವರಿಸಿ",
        problemAddress: "ಸಮಸ್ಯೆಯ ವಿಳಾಸ",
        captureLocation: "ಸಾಧನದ ಸ್ಥಳವನ್ನು ಸೆರೆಹಿಡಿ",
        captured: "ಸೆರೆಹಿಡಿದಿದೆ",
        submitComplaint: "ದೂರು ಸಲ್ಲಿಸಿ",
        geoNotSupported: "ಜಿಯೋಲೊಕೇಶನ್ ಬೆಂಬಲಿತವಲ್ಲ. ದಯವಿಟ್ಟು ವಿಳಾಸವನ್ನು ಕೈಯಾರೆ ನಮೂದಿಸಿ.",
        locationCaptured: "ಸಾಧನದಿಂದ ಸ್ಥಳವನ್ನು ಸೆರೆಹಿಡಿಯಲಾಗಿದೆ.",
        locationError: "ಸ್ಥಳವನ್ನು ಪಡೆಯಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ವಿಳಾಸವನ್ನು ಕೈಯಾರೆ ನಮೂದಿಸಿ.",
        noLocationConfirm: "ಯಾವುದೇ ಸಾಧನ ಸ್ಥಳವನ್ನು ಸೆರೆಹಿಡಿಯಲಾಗಿಲ್ಲ. ಕೇವಲ ಕೈಯಾರೆ ವಿಳಾಸದೊಂದಿಗೆ ಸಲ್ಲಿಸಬೇಕೇ?",
        complaintSubmitted: "ದೂರು ಸಲ್ಲಿಸಲಾಗಿದೆ",
        complaintError: "ದೂರು ಸಲ್ಲಿಸುವಲ್ಲಿ ದೋಷ",

        // GrievanceSelection
        selectGrievance: "ದೂರು ಆಯ್ಕೆಮಾಡಿ",
        selectGrievanceInstruction: "ಮುಂದುವರಿಯಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ದೂರು ಆಯ್ಕೆಮಾಡಿ",
        waterIssue: "ನೀರಿನ ಸಮಸ್ಯೆ",
        electricityIssue: "ವಿದ್ಯುತ್ ಸಮಸ್ಯೆ",
        roadDamage: "ರಸ್ತೆ ಹಾನಿ",
        streetlightsIssue: "ರಸ್ತೆ ದೀಪಗಳ ಸಮಸ್ಯೆ",
        sanitation: "ಸ್ವಚ್ಛತೆ",
        health: "ಆರೋಗ್ಯ",
        education: "ಶಿಕ್ಷಣ",
        wasteManagement: "ಅಪಚಯ ನಿರ್ವಹಣೆ",
        publicSafety: "ಸಾರ್ವಜನಿಕ ಸುರಕ್ಷತೆ",
        other: "ಇತರೆ",

        // AdminComplaints
        loadingComplaints: "ದೂರುಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
        complaintsManagement: "ದೂರು ನಿರ್ವಹಣೆ",
        update: "ನವೀಕರಿಸಿ",
        pending: "ಬಾಕಿ",
        accepted: "ಸ್ವೀಕರಿಸಲಾಗಿದೆ",
        rejected: "ತಿರಸ್ಕರಿಸಲಾಗಿದೆ",
        completed: "ಪೂರ್ಣಗೊಂಡಿದೆ",

        // AdminDashboard
        allComplaints: "ಎಲ್ಲಾ ದೂರುಗಳು",
        filterComplaints: "ದೂರುಗಳನ್ನು ಫಿಲ್ಟರ್ ಮಾಡಿ",
        userName: "ಬಳಕೆದಾರರ ಹೆಸರು",
        allStatus: "ಎಲ್ಲಾ ಸ್ಥಿತಿ",
        apply: "ಅನ್ವಯಿಸಿ",
        reset: "ಮರುಹೊಂದಿಸಿ",
        problemAddress: "ಸಮಸ್ಯೆಯ ವಿಳಾಸ",
        deviceLocation: "ಸಾಧನದ ಸ್ಥಳ",
        action: "ಕ್ರಿಯೆ",
        errorFetchingComplaints: "ದೂರುಗಳನ್ನು ಪಡೆಯುವಲ್ಲಿ ದೋಷ",
        addressNotFound: "ವಿಳಾಸ ಕಂಡುಬಂದಿಲ್ಲ",
        reverseGeocodeError: "ರಿವರ್ಸ್ ಜಿಯೋ ಕೋಡ್ ದೋಷ",

        // AdminUsers
        loadingUsers: "ಬಳಕೆದಾರರನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
        allUsers: "ಎಲ್ಲಾ ಬಳಕೆದಾರರು",
        filterUsers: "ಬಳಕೆದಾರರನ್ನು ಫಿಲ್ಟರ್ ಮಾಡಿ",
        searchByName: "ಹೆಸರಿನಿಂದ ಹುಡುಕಿ",
        searchByEmail: "ಇಮೇಲ್ ಮೂಲಕ ಹುಡುಕಿ",
        searchByPhone: "ಫೋನ್ ಮೂಲಕ ಹುಡುಕಿ",
        allKyc: "ಎಲ್ಲಾ KYC",
        kycStatus: "KYC ಸ್ಥಿತಿ",
        details: "ವಿವರಗಳು",
        kycCompleted: "KYC ಪೂರ್ಣಗೊಂಡಿದೆ",
        yes: "ಹೌದು",
        no: "ಇಲ್ಲ",
        aadhaarNumber: "ಆಧಾರ್ ಸಂಖ್ಯೆ",
        totalComplaints: "ಒಟ್ಟು ದೂರುಗಳು",
        close: "ಮುಚ್ಚಿ",

        //AdminUsers
        adminLogin: "ನಿರ್ವಾಹಕ ಲಾಗಿನ್",
        email: "ಇಮೇಲ್",
        password: "ಪಾಸ್ವರ್ಡ್",
        login: "ಲಾಗಿನ್",
        invalidCredentials: "ಅಮಾನ್ಯ ದಾಖಲೆಗಳು"
      }
    }
  },
  lng: localStorage.getItem("lang") || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});



export default i18n;